
import styles from '../ProductInfo.module.css';

// We will implement the actual logic in the next steps
interface DateInputProps {
    day: string;
    setDay: (val: string) => void;
    month: string;
    setMonth: (val: string) => void;
    year: string;
    setYear: (val: string) => void;
    format: 'numeric' | 'text';
    setFormat: (val: 'numeric' | 'text') => void;
    hasTopPadding?: boolean;
}

const FRENCH_MONTHS = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
];

export const DateInput = ({
    day, setDay,
    month, setMonth,
    year, setYear,
    format, setFormat,
    hasTopPadding
}: DateInputProps) => {
    return (
        <>
            <h4
                className={styles.customizationTitle}
                style={hasTopPadding ? { paddingTop: '20px' } : undefined}
            >
                Définissez la date du mariage
            </h4>

            {/* Format Selection - visual placeholder based on user request */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '15px' }}>
                <div
                    style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                    onClick={() => setFormat('numeric')}
                >
                    <div style={{
                        width: '20px', height: '20px',
                        border: '1px solid #000',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: format === 'numeric' ? '#000' : 'white',
                        color: 'white'
                    }}>
                        {format === 'numeric' && '✓'}
                    </div>
                    <span>Format : 15.08.2025</span>
                </div>

                <div
                    style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                    onClick={() => setFormat('text')}
                >
                    <div style={{
                        width: '20px', height: '20px',
                        border: '1px solid #000',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: format === 'text' ? '#000' : 'white',
                        color: 'white'
                    }}>
                        {format === 'text' && '✓'}
                    </div>
                    <span>Format : 15 août 2025</span>
                </div>
            </div>

            {/* Date Inputs */}
            <div className={styles.initialsWrapper}>
                <input
                    maxLength={2}
                    type="text"
                    className={styles.initialInput}
                    placeholder="DD"
                    value={day}
                    onChange={(e) => setDay(e.target.value)}
                />

                {format === 'numeric' ? (
                    <input
                        maxLength={2}
                        type="text"
                        className={styles.initialInput}
                        placeholder="MM"
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                    />
                ) : (
                    <div className={styles.separatorSelectWrapper}>
                        <select
                            className={styles.separatorSelect}
                            style={{ width: '120px', textAlign: 'left' }}
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                        >
                            <option value="">Mois</option>
                            {FRENCH_MONTHS.map((m) => (
                                <option key={m} value={m}>{m}</option>
                            ))}
                        </select>
                    </div>
                )}


                <input
                    maxLength={4}
                    type="text"
                    className={styles.initialInput}
                    style={{ width: '60px' }} // Wider for year
                    placeholder="YYYY"
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                />
            </div>
        </>
    );
};
